import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\agent-registration\\components\\IncomeCalculatorSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\agent-registration\\components\\RegistrationFormCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\homepage\\components\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\components\\common\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\components\\ui\\AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\components\\ui\\AppImage.tsx");
;
import(/* webpackMode: "eager" */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\imgs\\agen-surilipat.webp");
